
import { useCallback } from "react";

interface UseZoomControlsProps {
  graphRef: React.MutableRefObject<any>;
  INITIAL_ZOOM_FACTOR: number;
}

export const useZoomControls = ({ 
  graphRef, 
  INITIAL_ZOOM_FACTOR 
}: UseZoomControlsProps) => {
  const handleZoomIn = useCallback(() => {
    if (graphRef.current) {
      const currentZoom = graphRef.current.zoom();
      console.log(`Zooming in from ${currentZoom} to ${currentZoom * 1.5}`);
      graphRef.current.zoom(currentZoom * 1.5, 300);
    }
  }, [graphRef]);

  const handleZoomOut = useCallback(() => {
    if (graphRef.current) {
      const currentZoom = graphRef.current.zoom();
      console.log(`Zooming out from ${currentZoom} to ${currentZoom / 1.5}`);
      graphRef.current.zoom(currentZoom / 1.5, 300);
    }
  }, [graphRef]);

  const applyInitialZoom = useCallback(() => {
    if (!graphRef.current || initialZoomApplied.current) return;
    
    try {
      const currentZoom = graphRef.current.zoom();
      console.log(`Current zoom before adjustment: ${currentZoom}`);
      
      const newZoom = currentZoom * INITIAL_ZOOM_FACTOR;
      console.log(`Applying zoom: ${newZoom} (${currentZoom} × ${INITIAL_ZOOM_FACTOR})`);
      
      graphRef.current.zoom(newZoom, 500);
      
      initialZoomApplied.current = true;
    } catch (err) {
      console.error("Error applying initial zoom:", err);
    }
  }, [INITIAL_ZOOM_FACTOR, graphRef]);

  // Track whether initial zoom has been applied
  const initialZoomApplied = { current: false };

  return {
    handleZoomIn,
    handleZoomOut,
    applyInitialZoom,
    initialZoomApplied
  };
};
